/**
 * Sold-out PDP only: block Mulberry protection upsell and keep Notify Me / BIS form.
 *
 * Hard-refresh / CTA fix:
 * - Add to Cart (Accept): always add mattress (+ checked protector) + Mulberry plan
 * - "I don't want to protect" (Decline): always add mattress (+ checked protector), no plan
 * We add via /cart/add.js and briefly suppress Mulberry's follow-up origin-ATC
 * re-click so warm loads do not double-add.
 *
 * Does not stack Mulberry + Cooling upsell modals (CTAs are mutually exclusive).
 * Does not alter Rebuy cross-sell or Mulberry open/close beyond sold-out / upsell guard.
 */
(function () {
  if (window.__zinusMulberrySoldOutGuard) return;
  window.__zinusMulberrySoldOutGuard = true;

  var bypassNotifyClick = false;
  var notifyLockUntil = 0;
  var suppressOriginAtcUntil = 0;
  var addMattressTimer = null;

  function mainSoldOutWrapper() {
    return (
      document.querySelector('.product-submit-form > .product__form__wrapper.variant--soldout') ||
      document.querySelector('custom-product .product__block.product__form__wrapper.variant--soldout') ||
      document.querySelector('.product-single .product__block.product__form__wrapper.variant--soldout')
    );
  }

  function isMainPdpSoldOut() {
    return !!mainSoldOutWrapper();
  }

  function soldOutWrapperFor(node) {
    if (!node || !node.closest) return null;
    var wrapper = node.closest('.product__form__wrapper, [data-form-wrapper]');
    if (!wrapper || !wrapper.classList.contains('variant--soldout')) return null;
    // Ignore quick-view / unrelated wrappers unless it's the main PDP form.
    if (wrapper.closest('.popup-quick-view')) return wrapper;
    if (mainSoldOutWrapper()) return wrapper;
    return null;
  }

  function getNotifyButton(fromEl) {
    var wrapper = soldOutWrapperFor(fromEl) || mainSoldOutWrapper();
    if (!wrapper) return null;
    return (
      wrapper.querySelector('.notify-button[data-notification-popup]') ||
      wrapper.querySelector('.product__submit__add.actived[data-notification-popup]') ||
      wrapper.querySelector('[data-add-to-cart][data-notification-popup]')
    );
  }

  function closeMulberryUi() {
    try {
      if (window.mulberry && mulberry.modal && typeof mulberry.modal.close === 'function') {
        mulberry.modal.close();
      }
    } catch (e) {}
    try {
      if (window.pdpModal && typeof window.pdpModal.close === 'function') {
        window.pdpModal.close();
      }
    } catch (e) {}
    document.querySelectorAll('.mulberry-popup.active').forEach(function (el) {
      el.classList.remove('active');
      el.setAttribute('aria-hidden', 'true');
    });
    var loadingOverlay = document.getElementById('modal-loading-overlay');
    if (loadingOverlay) loadingOverlay.classList.remove('is-visible');
  }

  function openBackInStockForm(sourceBtn) {
    var now = Date.now();
    if (now < notifyLockUntil) return;
    notifyLockUntil = now + 800;

    var notifyBtn = getNotifyButton(sourceBtn);
    if (!notifyBtn || !notifyBtn.getAttribute('data-notification-popup')) return;

    bypassNotifyClick = true;
    closeMulberryUi();

    window.setTimeout(function () {
      try {
        notifyBtn.dispatchEvent(
          new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
        );
      } catch (e) {
        notifyBtn.click();
      }
      window.setTimeout(function () {
        bypassNotifyClick = false;
      }, 0);
    }, 0);
  }

  function getMainPdpVariantId() {
    var form =
      document.querySelector('.product-submit-form form.product__form[data-product-form]') ||
      document.querySelector('.product-submit-form form.product__form') ||
      document.querySelector('custom-product form.product__form[data-product-form]') ||
      document.querySelector('.product-single form.product__form[data-product-form]');

    if (
      form &&
      form.closest(
        '.upsell-popup__wrapper, .upsell-popup__container, .rebuy_popup-wrapper, .mulberry-popup, .popup-quick-view'
      )
    ) {
      form = null;
    }

    if (form) {
      var input = form.querySelector('input[name="id"][data-product-select], input[name="id"]');
      if (input && input.value) return String(input.value);
      var select = form.querySelector('select[name="id"]');
      if (select && select.value) return String(select.value);
    }

    try {
      var fromUrl = new URLSearchParams(window.location.search).get('variant');
      if (fromUrl) return String(fromUrl);
    } catch (e) {}

    return '';
  }

  function getMainPdpQuantity() {
    var form =
      document.querySelector('.product-submit-form form.product__form') ||
      document.querySelector('custom-product form.product__form');
    if (
      form &&
      form.closest(
        '.upsell-popup__wrapper, .rebuy_popup-wrapper, .mulberry-popup, .popup-quick-view'
      )
    ) {
      form = null;
    }
    var qty = form && form.querySelector('[name="quantity"]');
    var n = qty ? parseInt(qty.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function refreshCartUi() {
    try {
      if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
    } catch (e) {}
    try {
      if (typeof window.updateCartStatus === 'function') window.updateCartStatus();
    } catch (e) {}
  }

  /** True when Cooling upgrade CTA replaced the origin ATC (buttons are mutually exclusive). */
  function isUpsellCtaActive() {
    var upsellBtn = document.querySelector('.upsell-popup__button:not(.hidden)');
    if (!upsellBtn) return false;
    var originRow = document.querySelector(
      '.product_add_to_cart-button .product__submit__item'
    );
    if (originRow && originRow.classList.contains('hidden')) return true;
    return false;
  }

  function isUpsellModalOpen() {
    var modal = document.querySelector('.upsell-popup__wrapper');
    if (!modal) return false;
    if (modal.classList.contains('hidden')) return false;
    if (modal.getAttribute('aria-hidden') === 'true') return false;
    return true;
  }

  /** Open Cooling upgrade via the real upsell button (not Mulberry's CTA clone). */
  function openUpsellFromOriginalButton() {
    var buttons = document.querySelectorAll('.upsell-popup__button');
    var original = null;
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.classList.contains('hidden')) continue;
      try {
        if (btn.style.display === 'none' || window.getComputedStyle(btn).display === 'none') {
          original = btn;
          break;
        }
      } catch (e) {}
    }
    if (!original) original = document.querySelector('.upsell-popup__button:not(.hidden)');
    if (!original) return;
    try {
      original.click();
    } catch (e2) {}
  }

  function patchMulberryModalOpen() {
    if (!window.mulberry || !mulberry.modal || mulberry.modal.__zinusSoldOutPatched) {
      return !!(window.mulberry && mulberry.modal && mulberry.modal.__zinusSoldOutPatched);
    }

    var modal = mulberry.modal;
    var originalOpen = typeof modal.open === 'function' ? modal.open.bind(modal) : null;
    if (originalOpen) {
      modal.open = function () {
        if (isMainPdpSoldOut()) {
          closeMulberryUi();
          openBackInStockForm();
          return;
        }
        // Never open Mulberry on top of Cooling upsell (one popup only).
        if (isUpsellCtaActive() || isUpsellModalOpen()) {
          closeMulberryUi();
          return;
        }
        return originalOpen.apply(this, arguments);
      };
    }
    modal.__zinusSoldOutPatched = true;
    return true;
  }

  function patchAddWarrantyToCart() {
    if (!window.mulberryShop || typeof mulberryShop.addWarrantyToCart !== 'function') return false;
    if (mulberryShop.__zinusSoldOutPatched) return true;

    var originalAdd = mulberryShop.addWarrantyToCart.bind(mulberryShop);
    mulberryShop.addWarrantyToCart = function () {
      if (isMainPdpSoldOut()) {
        closeMulberryUi();
        window.setTimeout(stripOrphanMulberryPlans, 500);
        return Promise.resolve();
      }

      // Never let Mulberry Accept/Decline add when the upgrade CTA is the active button.
      if (isUpsellCtaActive() || isUpsellModalOpen()) {
        closeMulberryUi();
        return Promise.resolve();
      }

      // Always add the mattress for this Accept (qty increases if already in cart).
      // Do not wrap/await — Mulberry must close the modal immediately.
      var variantId = getMainPdpVariantId();
      var quantity = getMainPdpQuantity();
      try {
        var productArg = arguments.length > 1 ? arguments[1] : null;
        if (productArg && productArg.variantId) variantId = String(productArg.variantId);
      } catch (e) {}

      scheduleAlwaysAddMattress(variantId, quantity);
      return originalAdd.apply(this, arguments);
    };
    mulberryShop.__zinusSoldOutPatched = true;
    return true;
  }

  function isWarrantyItem(item) {
    if (!item) return false;
    var props = item.properties || {};
    if (props._warranty_duration_months != null || props._warranty_offer_id != null) {
      return true;
    }
    var type = String(item.product_type || '');
    var title = String(item.product_title || item.title || '');
    var vendor = String(item.vendor || '');
    return (
      /protection plan|mulberry|insurance/i.test(type) ||
      /mulberry|protection plan/i.test(title) ||
      /mulberry/i.test(vendor)
    );
  }

  /**
   * Checked "Add … Mattress Protector" cross-sell (cross_widget).
   * Theme writes items[1][id] into the form; Mulberry ATC never submits that form.
   */
  function getCheckedCrossWidgetVariantId() {
    var checkbox = document.querySelector('.cross_widget #cross_widget');
    if (!checkbox || !checkbox.checked) return '';
    var widget = checkbox.closest('.cross_widget');
    // Hidden = size OOS / unavailable — never add protector (would fail whole cart/add).
    if (!widget || widget.classList.contains('hidden')) return '';

    var hidden = document.querySelector(
      '.cross_widget_product input[name="items[1][id]"], .product-submit-form input[name="items[1][id]"]'
    );
    if (hidden && hidden.value) return String(hidden.value);

    var title = document.querySelector('.cross_widget .product_title');
    if (title && title.getAttribute('data-product-id')) {
      return String(title.getAttribute('data-product-id'));
    }
    return '';
  }

  /**
   * Always add the PDP mattress for Mulberry Accept/Decline.
   * If the protector cross-widget is checked, add that variant in the same request.
   */
  function addMattressToCart(variantId, quantity) {
    if (!variantId || isMainPdpSoldOut()) return;

    var items = [
      {
        id: Number(variantId) || variantId,
        quantity: quantity || 1
      }
    ];

    var protectorId = getCheckedCrossWidgetVariantId();
    if (protectorId && String(protectorId) !== String(variantId)) {
      items.push({
        id: Number(protectorId) || protectorId,
        quantity: 1
      });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (res && res.ok) refreshCartUi();
      })
      .catch(function () {});
  }

  function scheduleAlwaysAddMattress(variantId, quantity) {
    if (!variantId || isMainPdpSoldOut()) return;

    // Block Mulberry's programmatic origin ATC re-click; we own the mattress add.
    suppressOriginAtcUntil = Date.now() + 2500;

    if (addMattressTimer) window.clearTimeout(addMattressTimer);
    addMattressTimer = window.setTimeout(function () {
      addMattressTimer = null;
      addMattressToCart(variantId, quantity || 1);
    }, 300);
  }

  /**
   * Decline ("I don't want to protect"): mattress only, never a Mulberry plan.
   * Mulberry's own handler only re-clicks ATC — that fails after hard refresh.
   */
  function onMulberryDeclineAddMattressOnly() {
    if (isMainPdpSoldOut()) return;
    // Decline on Mulberry only — never when upgrade CTA/modal owns the flow.
    if (isUpsellCtaActive() || isUpsellModalOpen()) {
      closeMulberryUi();
      return;
    }
    scheduleAlwaysAddMattress(getMainPdpVariantId(), getMainPdpQuantity());
  }

  function isDeclineLabel(text) {
    var label = String(text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    if (!label || label.length > 100) return false;
    return (
      label.indexOf("don't want to protect") !== -1 ||
      label.indexOf('do not want to protect') !== -1 ||
      label.indexOf('no thanks') !== -1 ||
      label.indexOf('no, thanks') !== -1
    );
  }

  function patchMulberryModalInit() {
    if (!window.mulberry || !mulberry.modal || typeof mulberry.modal.init !== 'function') {
      return !!(window.mulberry && mulberry.modal && mulberry.modal.__zinusDeclinePatched);
    }
    if (mulberry.modal.__zinusDeclinePatched) return true;

    var originalInit = mulberry.modal.init.bind(mulberry.modal);
    mulberry.modal.init = function (options) {
      var opts = options || {};
      var userDecline = opts.onWarrantyDecline;
      opts.onWarrantyDecline = function () {
        onMulberryDeclineAddMattressOnly();
        if (typeof userDecline === 'function') {
          return userDecline.apply(this, arguments);
        }
      };
      return originalInit.call(this, opts);
    };
    mulberry.modal.__zinusDeclinePatched = true;
    return true;
  }

  function stripOrphanMulberryPlans() {
    if (!isMainPdpSoldOut()) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;
        var hasWarranty = false;
        var hasProduct = false;
        cart.items.forEach(function (item) {
          if (isWarrantyItem(item)) hasWarranty = true;
          else hasProduct = true;
        });
        if (!(hasWarranty && !hasProduct)) return;

        var updates = {};
        cart.items.forEach(function (item) {
          if (isWarrantyItem(item) && item.key) updates[item.key] = 0;
        });
        if (!Object.keys(updates).length) return;

        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
          if (typeof window.updateCartStatus === 'function') window.updateCartStatus();
        });
      })
      .catch(function () {});
  }

  document.addEventListener(
    'click',
    function (ev) {
      if (bypassNotifyClick) return;
      var target = ev.target;
      if (!target || !target.closest) return;

      // Upsell / Rebuy / BIS: never treat as Mulberry. Close Mulberry if it somehow opened.
      if (
        target.closest(
          '.upsell-popup__wrapper, .upsell-popup__button, .upgrade_button, .upgrade_widget, .rebuy_popup-wrapper, .cross_product-checked, [data-notification], .product__notification, .pswp--notification'
        )
      ) {
        // During Mulberry Accept re-click, suppress upsell button so both modals cannot open.
        if (
          Date.now() < suppressOriginAtcUntil &&
          target.closest('.upsell-popup__button, .upgrade_button')
        ) {
          ev.preventDefault();
          ev.stopPropagation();
          if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
          return;
        }
        if (target.closest('.upsell-popup__button, .upgrade_button, .upgrade_widget')) {
          closeMulberryUi();
        }
        return;
      }

      // Decline / "I don't want to protect my purchase" → mattress only (no plan).
      // Only when Mulberry modal owns the click — not upsell "No Thanks".
      if (!isMainPdpSoldOut() && !isUpsellCtaActive() && !isUpsellModalOpen()) {
        var node = target;
        for (var i = 0; i < 6 && node; i++) {
          if (
            isDeclineLabel(node.textContent) ||
            isDeclineLabel(node.getAttribute && node.getAttribute('aria-label'))
          ) {
            onMulberryDeclineAddMattressOnly();
            break;
          }
          node = node.parentElement;
        }
      }

      var atc = target.closest(
        '[data-add-to-cart], .product__submit__add, .sticky-add-to-cart__btn'
      );
      if (!atc) return;
      if (atc.closest('.upsell-popup__wrapper, .upsell-popup__container, .upsell-popup__button')) {
        return;
      }

      // Mulberry Accept already queues our mattress add — ignore its ATC re-click only.
      if (!isMainPdpSoldOut() && Date.now() < suppressOriginAtcUntil) {
        ev.preventDefault();
        ev.stopPropagation();
        if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
        return;
      }

      var wrapper = soldOutWrapperFor(atc);
      var stickySoldOut =
        atc.classList.contains('sticky-add-to-cart__btn') && isMainPdpSoldOut();
      if (!wrapper && !stickySoldOut) return;

      ev.preventDefault();
      ev.stopPropagation();
      if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();

      closeMulberryUi();
      openBackInStockForm(atc);
    },
    true
  );

  var mo = new MutationObserver(function () {
    if (isMainPdpSoldOut()) {
      if (document.querySelector('.mulberry-popup.active')) closeMulberryUi();
      return;
    }
    // If Cooling upsell is open, Mulberry must not stay visible.
    if (isUpsellModalOpen() && document.querySelector('.mulberry-popup.active')) {
      closeMulberryUi();
    }
  });
  mo.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  (function patchFetchForSoldOutOrphans() {
    if (!window.fetch || window.fetch.__zinusMulberrySoldOutPatched) return;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
      return originalFetch.apply(this, args).then(function (response) {
        if (
          isMainPdpSoldOut() &&
          url &&
          (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1)
        ) {
          window.setTimeout(stripOrphanMulberryPlans, 500);
        }
        return response;
      });
    };
    window.fetch.__zinusMulberrySoldOutPatched = true;
  })();

  function tryPatch() {
    patchMulberryModalOpen();
    patchMulberryModalInit();
    patchAddWarrantyToCart();
  }

  tryPatch();
  document.addEventListener('DOMContentLoaded', tryPatch);
  window.addEventListener('load', tryPatch);
  var tries = 0;
  var retry = window.setInterval(function () {
    tries += 1;
    tryPatch();
    if (
      (window.mulberry &&
        mulberry.modal &&
        mulberry.modal.__zinusSoldOutPatched &&
        mulberry.modal.__zinusDeclinePatched &&
        window.mulberryShop &&
        mulberryShop.__zinusSoldOutPatched) ||
      tries > 40
    ) {
      window.clearInterval(retry);
    }
  }, 250);
})();
